import { apiFetch } from '../utils/api';

export interface ProductAttribute {
  id: string;
  erpId: number;
  name: string;
  key: string;
  defaultValue: string | null;
  options: string[];
  isRequired: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface PaginatedAttributesResponse {
  data: ProductAttribute[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export const fetchProductAttributes = (params: {
  page?: number;
  limit?: number;
  search?: string;
} = {}): Promise<PaginatedAttributesResponse> => {
  const searchParams = new URLSearchParams();

  if (params.page) {
    searchParams.set('page', String(params.page));
  }

  if (params.limit) {
    searchParams.set('limit', String(params.limit));
  }

  if (params.search) {
    searchParams.set('search', params.search);
  }

  const query = searchParams.toString();
  return apiFetch<PaginatedAttributesResponse>(
    `/product/attributes${query ? `?${query}` : ''}`,
  );
};

export const fetchProductAttribute = (id: string) =>
  apiFetch<ProductAttribute>(`/product/attributes/${id}`);
